// extracted by mini-css-extract-plugin
export default {"content":"ModalLevelInfo_content__zD16Q","description":"ModalLevelInfo_description__WgJYf"};